import styled from '@emotion/styled';
import React from 'react';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/actionOverview-14@3x.png';
import { color } from 'src/shared/styles/variables';

const HighlightText = styled('span')({
    color: color.blueLagoon,
});

export const ActionAndCommitmentStep = () => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading small>Taking Actions</S.StepHeading>
                <S.StepHeading>Action and Commitment</S.StepHeading>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow>
            <S.ContentColumn md={14}>
                <S.StepDescription small>
                    This week we are going to figure out{' '}
                    <HighlightText>
                        how to start living according to those values in the areas that are most
                        important to you.
                    </HighlightText>
                </S.StepDescription>
                <S.StepDescription small>
                    As an example, let’s say last week you said you wanted to spend more time on
                    your relationships and your value was being supportive. How can you put this
                    value into action? How could you be a more supportive friend or family member?
                    Maybe the answer is to call a friend you haven’t spoken to in a while, or to
                    make dinner for your partner when they’ve had a busy day, or to babysit so your
                    friend can go to an movie... It can be anything!
                </S.StepDescription>
                <S.StepDescription small>
                    To make it more likely that you will follow through, it can
                    <HighlightText> be helpful to be specific, pick a time,</HighlightText>
                    and
                    <HighlightText> set a reminder</HighlightText> . For example, “I will help Holly
                    pick up her new furniture on Wednesday at 5pm” and put it in your calendar to
                    remind yourself.
                </S.StepDescription>
            </S.ContentColumn>
            <S.ContentColumn md={10}>
                <S.StepIcon iconUrl={stepIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    </>
);
